import { useGetCustomerPayment } from 'common/queries-and-mutations/admin/customer';
import { Icon, Icons } from 'components/Icon';
import Breadcrumb from 'components/Navigation/Breadcrumb';
import { format } from 'date-fns';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { formatToMoney } from 'utils';
import success from '../../../../assets/success.png';
import error from '../../../../assets/error.png';

export default function PaymentDetails() {
  const { paymentId, customerId } = useParams();

  const { data } = useGetCustomerPayment({ paymentId: +paymentId! });

  return (
    <div>
      <Breadcrumb title="Payment Details" />
      <div className="mt-10 flex flex-col justify-center rounded-md bg-white p-10 pb-20">
        <Link to={`/admin/customers/payments/${customerId}`}>
          <div className="flex justify-end">
            <Icon name={Icons.Close} width={40} height={40} />
          </div>
        </Link>

        <div className="mt-10 flex flex-col items-center justify-center">
          <p className="mb-4 text-[40px] font-bold text-[#092C4C]">
            Payment {data?.status === 'success' ? 'Successful' : data?.status}
          </p>

          <img
            className="h-[90px] w-[90px]"
            src={data?.status === 'success' ? success : error}
          />
          {/* Icon here */}
          <span className="mt-4 text-base font-normal text-[#526477]">
            This transaction was{' '}
            {data?.status === 'success' ? 'successful' : data?.status}
          </span>

          <div className="mt-16 w-[35rem] space-y-5 text-[#526477]">
            <div className="flex justify-between">
              <p className="text-xl font-normal">Payment For:</p>
              <p className="text-right text-[22px] font-medium">
                {data?.planType}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-xl font-normal">Bank:</p>
              <p className="text-right text-[22px] font-medium">
                {data?.data?.authorization?.bank}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-xl font-normal">Amount:</p>
              <p className="text-right text-[22px] font-medium">
                {data?.amount && formatToMoney(data?.amount / 100 ?? 0)}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-xl font-normal">Date:</p>
              <p className="text-right text-[22px] font-medium">
                {data?.createdAt &&
                  format(new Date(data?.createdAt), 'dd MMM yyyy')}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-xl font-normal">Time:</p>
              <p className="text-right text-[22px] font-medium">
                {data?.createdAt && format(new Date(data?.createdAt), 'H:M a')}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-xl font-normal">Transaction ID:</p>
              <p className="text-right text-[22px] font-medium">
                {data?.reference}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
